import React, { useEffect, useState } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import './LessonModules.css';
import { checkLessonAccess } from '../../utils/checkLessonAccess';
import { saveLastLocation } from '../../utils/lastLocation';

const LessonVocab = () => {
  const { lessonId } = useParams();
  const navigate = useNavigate();

const [checkingAccess, setCheckingAccess] = useState(true);
const [warning, setWarning] = useState('');

  const [vocabData, setVocabData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(true);
  const [lessonTitle, setLessonTitle] = useState('');
  const [backgroundImage, setBackgroundImage] = useState('');
  const [vocabularyImage, setVocabularyImage] = useState('');
  const [expandedWordIndex, setExpandedWordIndex] = useState(null);
const location = useLocation();

useEffect(() => {
  // Save when this page is opened
  saveLastLocation(location.pathname);
}, [location.pathname]);

useEffect(() => {
  const verifyAccess = async () => {
    const lessonNum = parseInt(lessonId);
    const allowed = await checkLessonAccess(lessonNum);

    if (!allowed) {
      setWarning('🚫 This lesson is locked. Redirecting you to your dashboard...');
      setTimeout(() => {
        navigate('/dashboard');
      }, 2500);
    }

    setCheckingAccess(false);
  };

  verifyAccess();
}, [lessonId, navigate]);



  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await fetch(`/data/lesson${lessonId}-vocab.json`);
        const data = await res.json();

        setLessonTitle(data.title);
        setBackgroundImage(data.backgroundImage);
        setVocabularyImage(data.vocabularyImage);
        setVocabData(data.wordsAndDefinitions);
      } catch (error) {
        console.error('Error fetching lesson vocab data:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [lessonId]);

  const handleToggle = (index) => {
    setExpandedWordIndex(prevIndex => prevIndex === index ? null : index);
  };

  const handleNext = () => {
    navigate(`/lesson/${lessonId}/practice`);
  };

if (checkingAccess) return <div>Checking access...</div>;
if (warning) return <div style={{ padding: '40px', textAlign: 'center', color: 'crimson', fontSize: '18px' }}>{warning}</div>;
if (loading) return <div>Loading Vocabulary...</div>;
if (!vocabData || vocabData.length === 0) return <div>No vocabulary data found.</div>;



  return (
    <div className="lesson-vocab-container">

      {/* ✅ Hero Section */}
      <div
        className="hero-section"
        style={{
          backgroundImage: `url(${backgroundImage})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          padding: '60px 20px',
          color: '#fff',
          textAlign: 'center'
        }}
      >
        <h1>{lessonTitle}</h1>
      </div>

     {/* ✅ Vocabulary Image with modal overlay */}
{vocabularyImage && (
  <div
    style={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      margin: "30px 0",
    }}
  >
    {/* Inline image */}
    <img
      src={vocabularyImage}
      alt="Vocabulary Visual"
      style={{
        width: "100%",
        maxWidth: "600px",
        height: "auto",
        borderRadius: "10px",
        objectFit: "contain",
        cursor: "zoom-in",
        boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
      }}
      loading="lazy"
      onClick={() => setShowModal(true)}
    />

  

    {/* Modal overlay */}
    {showModal && (
      <div
        onClick={() => setShowModal(false)}
        style={{
          position: "fixed",
          inset: 0,
          backgroundColor: "rgba(0,0,0,0.85)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 1000,
          cursor: "zoom-out",
          padding: "10px",
        }}
      >
        <img
          src={vocabularyImage}
          alt="Vocabulary Visual enlarged"
          style={{
            maxWidth: "95vw",
            maxHeight: "90vh",
            borderRadius: "10px",
            objectFit: "contain",
          }}
        />
      </div>
    )}
  </div>
)}




      {/* ✅ Vocab List */}
      <ul
        className="vocab-list"
        style={{
          listStyleType: 'none',
          padding: 0,
          margin: 0,
          maxWidth: '800px',
          marginLeft: 'auto',
          marginRight: 'auto'
        }}
      >
        {vocabData.map((item, index) => (
          <li
            key={index}
            className={`vocab-word ${expandedWordIndex === index ? 'expanded' : ''}`}
            style={{
              border: '1px solid #ddd',
              borderRadius: '8px',
              padding: '15px',
              marginBottom: '10px',
              cursor: 'pointer',
              transition: 'background-color 0.3s'
            }}
            onClick={() => handleToggle(index)}
          >
            <div className="word-title">
              <strong>{item.word}</strong>: <span>{item.definition}</span>
            </div>

            {expandedWordIndex === index && (
              <div className="word-details" style={{ marginTop: '10px' }}>
                <p><strong>Example:</strong> {item.example}</p>
                <p><strong>Usage Tip:</strong> {item.usage}</p>
                <p><strong>Part of Speech:</strong> {item.partOfSpeech}</p>
              </div>
            )}
          </li>
        ))}
      </ul>

      {/* ✅ Navigation Button at the bottom */}
      <div style={styles.navigationButtons}>
        <button style={styles.navButton} onClick={handleNext}>
          Continue to Practice Activities
        </button>
      </div>

    </div>
  );
};

export default LessonVocab;

// Styles
const styles = {
  navigationButtons: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '40px',
    padding: '20px',
    borderTop: '2px solid #eee'
  },
  navButton: {
    padding: '12px 24px',
    fontSize: '18px',
    backgroundColor: '#007bff',
    color: '#fff',
    border: 'none',
    borderRadius: '8px',
    cursor: 'pointer',
    transition: 'background-color 0.3s',
  }
};
